import { styled } from "@mui/material"

export const QuestComp = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    width: "80%",
    justifyContent: 'space-between',
    alignItems: 'center'
}))
export const QuestText = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '0px'
}))
export const QuestTextRight = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    background: props.background ? props.background : 'transparent'
}))
export const NameQuest = styled('h6')(({ theme }) => (props) => ({
    fontSize: "14px",
    fontWeight: 400,
    width: '90%',
    padding: '2px',
    margin: '0',
    color: theme.palette.mode === "light" ? theme.palette.text.light : theme.palette.text.dark,
}))
export const QuestDetails = styled('p')(({ theme }) => (props) => ({
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "17px",
    width: '100%',
    padding: props.padding,
    margin: '0',
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
}))
export const ImageQuest = styled('div')(({ theme }) => (props) => ({
    width: '48px',
    height: '48px'
}))
export const UserImage = styled('img')(({ theme }) => (props) => ({
    height: '100%',
    width: '100%',
    borderRadius: '50%'
}))